export const buildHostedCheckoutUrls = (returnPath, email) => {
	const encodedReturnPath = encodeURIComponent(returnPath || '/chat');
	const encodedEmail = encodeURIComponent(email || '');
	const base = `${window.location.origin}/order-status`;

	return {
		successUrl: `${base}?result=success&paymentFor=tokens&returnPath=${encodedReturnPath}&email=${encodedEmail}&session_id={CHECKOUT_SESSION_ID}`,
		cancelUrl: `${base}?result=failed&paymentFor=tokens&returnPath=${encodedReturnPath}&email=${encodedEmail}&session_id={CHECKOUT_SESSION_ID}`,
	};
};
